<div class="container">

  <!-- HEADER -->
   <br>
  <header class="header">
    <h1>SIACEB</h1>
  </header>

  <!-- LOGIN CON IMAGEN -->
  <section class="login-section">
    <div class="login-img-container">
      <img  src="assets/img_plataformas/siaceb.png" alt="Login SIACEB">
    </div>
  </section>

  <!-- INFORMACIÓN -->
  <section class="info">
    <h3>INFORMACIÓN</h3> <br> 

    <p>
      La Plataforma SIACEB es uso exclusivo del Instituto Tecnológico Superior de Escárcega para Consulta de Calificaciones deL alumnado , Gestión de Calificaiones para Docentes y Gestión General para Personal Administrativo. La Plataforma se Encuentra Alojada en un Servidor Interno de la Institución por lo cual solo hay areas donde se puede acceder, para el alumnado y docentes (Centro de Computo, Sala de Maestro, Biblioteca, Sala de Idiomas) y para personal Administrativo en sus respectivos Departamentos. 
    </p>

    <p>
      Disponible en:
      <span class="highlight">
        Centro de Cómputo, Sala de Maestros, Biblioteca, Sala de Idiomas
      </span>
    </p>

    <h4>Pasos para el Alumno:</h4>
    <ul>
      <li>Nombre de Usuario(a): estudiante </li>
      <li> Nombre de Contraseña: estudiante </li>
      <li> Información - Carga Materias o Consulta Parcial </li>
      <li> Ingresar Matricula APELLIDO PATERNO (En Mayúsculas)</li>
    </ul>
    <br>

    <a href="http://192.168.1.9/SIACEB/administrator/" class="link">SIACEB</a> <br>
    <br>

    <p class="responsable">
      <b>RESPONSABLE:</b><br>
      LDO. MANUEL J. FRANCO QUEB
    </p>
  </section>
<br><br><br>

</div>

